import { render } from "./Exchange.vue?vue&type=template&id=3de2bfc0&ts=true"
import script from "./Exchange.vue?vue&type=script&lang=ts"
export * from "./Exchange.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__